export default {
    NO_ITEM_SELECTED: 'You have not selected an item to enchant.',
    CANNOT_ENCHANT: 'The item you have selected cannot be enchanted.',
    NO_SHARD: 'You must provide a shard to enchant an item.',
    FAILED_ENCHANT: 'You tried enchanting but nothing happened.',
    SUCCESSFUL_ENCHANT: 'You successfully enchanted your item.'
} as const;
